// extracted by mini-css-extract-plugin
export default {"header-logo-container":"style_header-logo-container__g6-KX","logo":"style_logo__gqD-k"};